import type { Activity, ActivityType, VibrationMode } from './activity';

export interface DownloadQuery {
  // Patient selection
  patientIds: string[];           // Selected patient IDs (empty = all)

  // Activity filters
  activityTypes: ActivityType[];  // Selected types (empty = all)
  vibrationModes: VibrationMode[]; // Selected modes (empty = all)

  // Date range
  dateRange: {
    from: string | null;          // ISO date or null for no limit
    to: string | null;
  };
}

export interface DownloadPreview {
  activities: Activity[];         // Paginated preview
  totalCount: number;             // Total matching activities
  patientCount: number;           // Number of patients included
  page: number;
  pageSize: number;
  hasMore: boolean;
}

export interface DownloadRequest {
  data: Array<{
    token: string;                // Patient's access token
    user_id: string;              // Patient username
    activities: string[];         // Activity IDs to download
  }>;
}

export type DownloadStructure = 'flat' | 'folders';

export type DownloadStatus = 'idle' | 'fetching' | 'packaging' | 'complete' | 'error';

export interface DownloadProgress {
  status: DownloadStatus;
  current: number;
  total: number;
  message?: string;
}

export const INITIAL_DOWNLOAD_QUERY: DownloadQuery = {
  patientIds: [],
  activityTypes: [],
  vibrationModes: [],
  dateRange: {
    from: null,
    to: null,
  },
};

export const INITIAL_DOWNLOAD_PROGRESS: DownloadProgress = {
  status: 'idle',
  current: 0,
  total: 0,
};
